(() => {
  const config = window.StoreConfig || {};
  const text = config.strings || {};
  const demo = document.body.dataset.demo === 'true';
  const root = config.root || '/';
  const money = value => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: config.currency || 'PLN', maximumFractionDigits: value % 100 === 0 ? 0 : 2 }).format(value / 100);
  const safe = value => String(value || '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const bundleConfig = product => ({ enabled: product?.dataset.bundleEnabled === 'true', discount: Math.max(0, Number(product?.dataset.bundleDiscount) || 0), minimum: Math.max(2, Number(product?.dataset.bundleMinimum) || 2) });
  const quotedTotal = (price, count, bundle) => Math.max(0, price * count - (bundle?.enabled && count >= bundle.minimum ? bundle.discount : 0));
  let demoCart = { items: [], item_count: 0, total_price: 0 };
  let cartBusy = false;
  const icon = '<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 7h12l1 14H5L6 7Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  const dialog = document.querySelector('[data-cart-dialog]');
  const resetTerms = scope => {
    scope.querySelectorAll('[data-terms-checkbox]').forEach(checkbox => {
      checkbox.checked = false;
      checkbox.setCustomValidity('');
      checkbox.removeAttribute('aria-invalid');
      const agreement = checkbox.closest('[data-terms-agreement]');
      agreement.querySelector('[data-terms-error]').hidden = true;
      agreement.querySelector('[data-terms-accepted-at]').value = '';
    });
  };
  const getCart = async () => {
    if (demo) return demoCart;
    const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(text.cartError || 'Nie udało się otworzyć koszyka.');
    return response.json();
  };
  const renderCart = cart => {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    if (!dialog) return;
    const body = dialog.querySelector('[data-cart-body]');
    const foot = dialog.querySelector('[data-cart-foot]');
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty">' + icon + '<p>' + safe(text.empty || 'Twój koszyk jest pusty.') + '</p><button class="button button--outline" data-cart-close>' + safe(text.continue || 'Wróć do opaski') + '</button></div>';
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(item => '<article class="cart-line"><img src="' + safe(item.featured_image?.url || item.image || config.demoImage || '') + '" alt="' + safe(item.product_title || item.title) + '" width="84" height="108"><div><h3>' + safe(item.product_title || item.title) + '</h3><div class="cart-line-bottom"><strong>' + money(item.final_line_price) + '</strong><button class="text-link" data-cart-change="' + safe(item.key) + '" data-value="0">' + safe(text.remove || 'Usuń') + '</button></div><div class="quantity"><button aria-label="' + safe(text.decrease || 'Zmniejsz liczbę sztuk') + '" data-cart-change="' + safe(item.key) + '" data-value="' + (item.quantity - 1) + '">−</button><input aria-label="' + safe(text.quantity || 'Liczba sztuk') + '" value="' + item.quantity + '" readonly><button aria-label="' + safe(text.increase || 'Zwiększ liczbę sztuk') + '" data-cart-change="' + safe(item.key) + '" data-value="' + (item.quantity + 1) + '">+</button></div></div></article>').join('');
    dialog.querySelector('[data-cart-total]').textContent = money(cart.total_price);
  };
  const openCart = async () => {
    if (!dialog) { window.location.href = config.cartUrl || root + 'cart'; return; }
    const error = dialog.querySelector('[data-cart-error]');
    error.hidden = true;
    resetTerms(dialog);
    if (!dialog.open) dialog.showModal();
    try { renderCart(await getCart()); } catch (err) { error.textContent = err.message; error.hidden = false; }
  };
  document.addEventListener('click', async event => {
    const open = event.target.closest('[data-cart-open]');
    if (open) { event.preventDefault(); openCart(); }
    if (event.target.closest('[data-cart-close]')) dialog?.close();
    const menu = event.target.closest('[data-menu-toggle]');
    if (menu) { const nav = document.getElementById(menu.getAttribute('aria-controls')); const expanded = menu.getAttribute('aria-expanded') === 'true'; menu.setAttribute('aria-expanded', String(!expanded)); nav.hidden = expanded; }
    if (event.target.closest('.mobile-nav a')) { document.querySelector('.mobile-nav').hidden = true; document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', 'false'); }
    const change = event.target.closest('[data-cart-change]');
    if (change && !cartBusy) {
      cartBusy = true;
      const error = dialog.querySelector('[data-cart-error]'); error.hidden = true;
      try {
        if (demo) {
          const quantity = Math.max(0, Number(change.dataset.value) || 0);
          demoCart.items = demoCart.items.map(item => item.key === change.dataset.cartChange ? { ...item, quantity, final_line_price: quotedTotal(item.unit_price, quantity, item.bundle) } : item).filter(item => item.quantity > 0);
          demoCart.item_count = demoCart.items.reduce((sum, item) => sum + item.quantity, 0); demoCart.total_price = demoCart.items.reduce((sum, item) => sum + item.final_line_price, 0);
          renderCart(demoCart);
        } else {
          const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.value) }) });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || text.cartError);
          renderCart(data);
        }
      } catch (err) { error.textContent = err.message; error.hidden = false; }
      finally { cartBusy = false; }
    }
  });
  dialog?.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) dialog.close(); });
  const init = scope => {
    scope.querySelectorAll('[data-cart-checkout-form]:not([data-terms-ready])').forEach(form => {
      form.dataset.termsReady = 'true';
      const checkbox = form.querySelector('[data-terms-checkbox]');
      const agreement = checkbox.closest('[data-terms-agreement]');
      const error = agreement.querySelector('[data-terms-error]');
      const acceptedAt = agreement.querySelector('[data-terms-accepted-at]');
      checkbox.checked = false;
      checkbox.addEventListener('invalid', () => {
        checkbox.setCustomValidity(checkbox.dataset.termsRequired);
        checkbox.setAttribute('aria-invalid', 'true');
        error.hidden = false;
      });
      checkbox.addEventListener('change', () => {
        checkbox.setCustomValidity('');
        checkbox.removeAttribute('aria-invalid');
        error.hidden = true;
        acceptedAt.value = checkbox.checked ? new Date().toISOString() : '';
      });
      form.addEventListener('submit', event => {
        if (event.submitter?.name === 'checkout') {
          if (!checkbox.checked) {
            event.preventDefault();
            checkbox.reportValidity();
            return;
          }
          acceptedAt.value = new Date().toISOString();
        }
      });
    });

    scope.querySelectorAll('[data-gallery]:not([data-ready])').forEach(gallery => {
      gallery.dataset.ready = 'true';
      const main = gallery.querySelector('[data-gallery-main]');
      const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
      let current = 0;
      const select = index => { current = (index + thumbs.length) % thumbs.length; const thumb = thumbs[current]; if (!thumb || !main) return; main.src = thumb.dataset.src; main.removeAttribute('srcset'); main.alt = thumb.dataset.alt || ''; thumbs.forEach((el, i) => el.setAttribute('aria-pressed', String(i === current))); };
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => select(i)));
      gallery.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => select(current + Number(button.dataset.galleryStep))));
    });
    scope.querySelectorAll('[data-buy-form]:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const quantity = form.querySelector('[name="quantity"]');
      const variant = form.querySelector('[name="id"]');
      const submit = form.querySelector('[type="submit"]');
      const bundles = [...form.querySelectorAll('[data-bundle]')];
      const product = form.closest('[data-product]');
      const bundle = bundleConfig(product);
      let price = Number(form.dataset.price || 25900);
      const update = () => {
        const selected = variant?.selectedOptions?.[0];
        if (selected) { price = Number(selected.dataset.price); submit.disabled = selected.dataset.available !== 'true'; }
        let count = Number(quantity.value); if (!Number.isFinite(count) || count < 1) count = 1; count = Math.floor(count); quantity.value = count;
        bundles.forEach(bundle => bundle.checked = Number(bundle.value) === count);
        form.querySelectorAll('[data-bundle-price]').forEach(el => el.textContent = money(quotedTotal(price, Number(el.dataset.bundlePrice), bundle)));
        product?.querySelectorAll('[data-current-price]').forEach(el => el.textContent = money(price));
        const comparePrice = Number(selected ? selected.dataset.comparePrice : product?.dataset.comparePriceValue) || 0;
        const onSale = comparePrice > price;
        product?.querySelectorAll('[data-compare-wrap], [data-sale-badge]').forEach(el => el.hidden = !onSale);
        product?.querySelectorAll('[data-compare-price]').forEach(el => el.textContent = money(comparePrice));
        product?.querySelectorAll('[data-sale-percent]').forEach(el => el.textContent = onSale ? Math.min(Math.round((comparePrice - price) / comparePrice * 100), Number(el.dataset.salePercentLimit) || 100) : 0);
        if (bundle.enabled && bundle.minimum <= 2) form.querySelectorAll('[data-bundle-unit]').forEach(el => el.textContent = 'Po ' + money(quotedTotal(price, 2, bundle) / 2) + ' za sztukę');
        form.querySelectorAll('[data-bundle-saving]').forEach(el => el.textContent = 'Oszczędzasz ' + money(Math.min(bundle.discount, price * 2)) + ' względem zakupu dwóch sztuk osobno');
        if (submit) submit.innerHTML = '<span>' + safe(submit.disabled ? text.unavailable || 'Niedostępny' : text.add || 'Dodaj do koszyka') + '</span>' + (submit.disabled ? '' : '<span>— ' + money(quotedTotal(price, count, bundle)) + '</span>');
      };
      bundles.forEach(bundle => bundle.addEventListener('change', () => { quantity.value = bundle.value; update(); }));
      form.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) + Number(button.dataset.quantityStep)); update(); }));
      quantity.addEventListener('change', update);
      variant?.addEventListener('change', update);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (submit.disabled) return;
        const error = form.querySelector('[data-form-error]'); error.hidden = true; submit.disabled = true; submit.textContent = text.adding || 'Dodawanie…';
        try {
          if (demo) {
            const count = Number(quantity.value) + demoCart.item_count;
            const total = quotedTotal(price, count, bundle);
            demoCart = { item_count: count, total_price: total, items: [{ key: 'demo', title: config.demoTitle || 'Masażer kolana', product_title: config.demoTitle || 'Masażer kolana', quantity: count, unit_price: price, bundle, final_line_price: total, image: config.demoImage }] };
          } else {
            const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || text.cartError || 'Nie udało się dodać produktu.');
          }
          await openCart();
        } catch (err) { error.textContent = err.message; error.hidden = false; }
        finally { submit.disabled = false; update(); }
      });
      update();
    });
    scope.querySelectorAll('[data-cart-page-quantity]').forEach(control => {
      control.querySelectorAll('[data-page-step]').forEach(button => button.addEventListener('click', () => { const input = control.querySelector('input'); input.value = Math.max(0, Number(input.value) + Number(button.dataset.pageStep)); }));
    });
  };
  init(document);
  window.addEventListener('pageshow', () => resetTerms(document));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.querySelectorAll('[data-demo-checkout]').forEach(button => button.addEventListener('click', () => { const error = dialog.querySelector('[data-cart-error]'); error.textContent = text.demoNotice || 'Podgląd sklepu. Składanie zamówień nie jest jeszcze dostępne.'; error.hidden = false; }));
})();

